import React, { Component } from "react";
import store from "@/redux/store";

import { createPortal } from 'react-dom';
import { Link, useNavigate, useLocation } from "react-router-dom";

import { BuildingOfficeIcon, CreditCardIcon, UserIcon, UsersIcon } from '@heroicons/react/20/solid'
import { useState } from 'react'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'

import { Edit as CustomerCompany } from "@/views/base/company/Edit";
import { useForm, SubmitHandler } from "react-hook-form"
import  {ICustomer} from "@/models/Customer";
import {FieldHolder} from "@/components/holders/FieldHolder";
import {showSettingsStorageBasemapSelect, hideModal} from "@/reducers/ModalPopup";
import {setStorageBaseMap, disconnectDropboxAccount} from "@/reducers/Settings";

export function Storage({...props}) {
  const { register, handleSubmit, watch, reset,    formState, setValue } = useForm({
      defaultValues: props.data,
      values: props.data
    })
    //setValue("type", props.data.type.toString() );
const [open, setOpen] = useState(false)

const tabs = [


  { name: 'Klant gegevens', href: '#', icon: UserIcon, current: true },
]  // More people...

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}
const disconnectAccount = (event) => {
    event.preventDefault();
    store.dispatch(disconnectDropboxAccount());
    return false;    
}
const showBaseMapSelectModal = (event) => {
    event.preventDefault();
    store.dispatch(showSettingsStorageBasemapSelect({dropbox: props.data.dropbox, action:setBaseMap}));
    return false;
}

const setBaseMap =(basemap) => {
    if(basemap) {
        store.dispatch(setStorageBaseMap({basemap: basemap}));
    }
}

   const onSubmit: SubmitHandler = (data) => {
    event.preventDefault();
    event.stopPropagation();

    props.onSaveHandler(data);
      
    return false;

    }
/*
  React.useEffect(() => {
      if(props.data && watch("key") != props.data.key) {
          reset(props.data);
      } else if(!props.data && formState.defaultValues && formState.defaultValues["key"] && formState.defaultValues["key"] != "") {
            for (const [key, value] of Object.entries(formState.defaultValues)) {
                formState.defaultValues[key] = "";
            }          
            reset(formState.defaultValues, { keepDirtyValues: true }); 
      }
  }, [formState, reset])
*/

  const onSaveWrapped = (data) => {
    event.preventDefault();
    event.stopPropagation();
    
    props.onSaveHandler(data);
      
    return false;
  };
  
  return (
    <>
                        
    <div className="space-y-10 divide-y divide-gray-900/10 mt-8">
      <div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-1">
       <form className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2" onSubmit={handleSubmit(onSubmit)}>

          <div className="px-4 py-6 sm:p-8">
            {typeof props?.data?.dropbox?.account == 'undefined' && 
                <div className="mt-1 space-y-8 pb-12 sm:space-y-0   sm:pb-0">
                    <a href={props.data.dropbox.authUrl} target="_blank" className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Koppel uw account met dropbox</a>
                </div>
                }
                {props?.data?.dropbox?.account?.name?.display_name && 
                <div className="mt-1 space-y-8 pb-12 sm:space-y-0   sm:pb-0">
                    Geconnect met {props?.data?.dropbox?.account?.name?.display_name}
            <button
              type="button"
              onClick={disconnectAccount}
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Disconnect
            </button>
                    
                </div>
                
                }
                
                {props?.data?.dropbox?.account?.name?.display_name && !props?.data?.dropbox?.baseMap && 
                <div className="mt-1 space-y-8 pb-12 sm:space-y-0   sm:pb-0">
                    U dient nog een hoofdmap te selecteren!
                    

            <button
              type="button"
              onClick={showBaseMapSelectModal}
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Selecteer hoofdmap
            </button>
                
                </div>
                }

                {props?.data?.dropbox?.baseMap && 
                <div className="mt-1 space-y-8 pb-12 sm:space-y-0   sm:pb-0">
                    Hoofdmap : {props?.data?.dropbox?.baseMap?.name}
                    

            <button
              type="button"
              onClick={showBaseMapSelectModal}
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Aanpassen hoofdmap
            </button>
                
                </div>
                }
                                
          </div>
        
        </form>
      </div>
      </div>

      {createPortal(
    <Dialog open={open} onClose={setOpen} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
     <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-sm sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
        </DialogPanel>
        </div>
        </div>
    </Dialog>,
        document.body
      )}

    </>
      );
}
